import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Segment } from 'semantic-ui-react';
import { Box, Flex, Divider } from 'rebass';
import { withApollo } from 'react-apollo';
import ReactGA from 'react-ga';

import ScoreForm from './ScoreForm.gql';
import { getMyMockExamResults } from '../../GraphQL/query/ScoreForm.query';
import LinkMockExamPanel from './LinkMockExamPanel';
import { COLOR, SPACE } from '../../Components/Theme';
import { Button as TCButton, Text, Link } from '../../Components/Base';
import TCIcon from '../../Components/TCIcon';

const CloseButton = styled(TCButton)`
  &&&& {
    padding: 0.4em 0.2em;
    margin-right: 0;
  }
`;

class ScoreFormLayout extends Component {
  static propTypes = {
    title: PropTypes.string,
    showClose: PropTypes.bool,
  };

  static defaultProps = {
    title: 'กรอกแล้วกดปุ่มคำนวณคะแนนข้างล่าง',
    showClose: false,
  };

  state = {
    mockExamScores: null,
  };

  handleLinkMockExam = examCards => {
    const { client } = this.props;
    const examCardIds = examCards.map(card => {
      return card.examCardId;
    });

    client
      .query({
        query: getMyMockExamResults,
        variables: { examCardIds: examCardIds },
      })
      .then(
        res => {
          const { myMockExamResults } = res.data;
          const mockExamScores = myMockExamResults.map(result => {
            const card = examCards.find(card => result.examId === card.examId);
            const { subjectCode } = card || {};
            return { subjectCode: subjectCode, score: result.score };
          });
          try {
            ReactGA.event({
              category: 'MOCKEXAM',
              action: 'Link score',
            });
          } catch (err) {
            console.err('ga error:', err);
          }
          this.setState({
            mockExamScores: mockExamScores,
          });
        },
        rejected => {
          try {
            ReactGA.event({
              category: 'MOCKEXAM',
              action: 'Link score rejected',
              label: JSON.stringify(rejected),
            });
          } catch (err) {
            console.err('ga error:', err);
          }
        }
      );
  };

  render() {
    const { title, showClose, onClose, ...restProps } = this.props;
    const { mockExamScores } = this.state;
    const Wrapper = showClose ? Fragment : Segment;
    return (
      <Box>
        {showClose && (
          <Flex justifyContent="flex-end">
            <CloseButton
              borderless
              onClick={onClose}
              inverted
              color="red"
              content={
                <span style={{ fontWeight: 400 }}>
                  <TCIcon name="close" />
                  ปิด
                </span>
              }
            />
          </Flex>
        )}
        <Wrapper>
          {title && (
            <Fragment>
              <Text.Title mb={SPACE.small}>{title}</Text.Title>
              <LinkMockExamPanel onSubmit={this.handleLinkMockExam} />
              <Divider borderColor={COLOR.greyscale.grey2} />
            </Fragment>
          )}
          <ScoreForm {...restProps} onSubmitted={onClose} mockExamScores={mockExamScores} />
        </Wrapper>
      </Box>
    );
  }
}

export default withApollo(ScoreFormLayout);

// This is mock data used to test.
// const mockMyMockExamResults = [{ examId: '3', score: 150 }, { examId: '1', score: 147 }];

// const mockMockExamScores = [
//   { subjectCode: '72', score: 75 },
//   { subjectCode: '73', score: 75 },
//   { subjectCode: '74', score: 75 },
// ];
